var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "master-filter app-filter hideLandscape"
  }, [_c('div', {
    staticClass: "app-filter-label"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "app-filter-select"
  }, [_c('b-dropdown', {
    ref: "dropdown-filters",
    attrs: {
      "variant": "link",
      "toggle-class": "app-filter-toggle",
      "menu-class": "app-filter-menu app-filter-menu--employees",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "app-filter-trigger"
        }, [_c('span', [_vm._v(_vm._s(_vm.active.name))]), _c('svg', {
          attrs: {
            "width": "14",
            "height": "14",
            "viewBox": "0 0 20 20",
            "fill": "none",
            "aria-hidden": "true"
          }
        }, [_c('path', {
          attrs: {
            "d": "M5 7.5L10 12.5L15 7.5",
            "stroke": "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })])])];
      },
      proxy: true
    }])
  }, _vm._l(_vm.dropdownOptions, function (item, key) {
    return _c('b-dropdown-item', {
      key: key,
      staticClass: "app-filter-item",
      "class": {
        'active-filter': _vm.active.id === item.id
      },
      attrs: {
        "link-class": "app-filter-option-link",
        "href": "#"
      },
      on: {
        "click": function click($event) {
          return _vm.filterBroker(item);
        }
      }
    }, [_c('div', {
      staticClass: "app-filter-option"
    }, [item.id ? _c('span', {
      staticClass: "app-filter-avatar"
    }, [item.profile_image ? _c('img', {
      attrs: {
        "src": item.profile_image,
        "alt": ""
      }
    }) : _c('span', [_vm._v(_vm._s(_vm.initials(item.name)))])]) : _vm._e(), _c('span', {
      staticClass: "app-filter-option-label"
    }, [_vm._v(_vm._s(item.name))]), _vm.active.id === item.id ? _c('span', {
      staticClass: "app-filter-check"
    }, [_vm._v("✓")]) : _vm._e()])]);
  }), 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }